// Guard against the "Failed to execute 'removeChild' on 'Node'" crash that
// happens when a browser's built-in page translation (Chrome/Edge/Safari) is
// active. The translator rewrites text nodes in place, so when React later
// unmounts a subtree the node it wants to remove/insert is no longer where it
// expects — and the raw DOM call throws, taking the whole app down.
//
// This makes removeChild/insertBefore no-op gracefully instead of throwing when
// the node isn't actually a child of the given parent. It lets foreign users
// keep the page translated; it just stops the translation from crashing React.
// Well-known mitigation, see facebook/react#11538.
export function installTranslationCrashFix() {
  if (typeof Node !== 'function' || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn('[celto] skipped removeChild on reparented node (browser translation)');
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined') {
        console.warn('[celto] skipped insertBefore on reparented node (browser translation)');
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
